// extracted by mini-css-extract-plugin
module.exports = {"star-animation":"StarAnimation_star-animation__18RIb"};